import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  quantidadeUsuariosPorDestaque?: number;
  queryKey?: string;
}
export function useGetDestaques(props: Props) {
  const hasParam = props.quantidadeUsuariosPorDestaque
    ? `?quantidadeUsuariosPorDestaque=${props.quantidadeUsuariosPorDestaque}`
    : "";
  const fetchData = async () => {
    const LISTAR_DESTAQUES = `${leadsWebEnviroment}/common/destaques/v1${hasParam}`;
    const response = await instance.get(LISTAR_DESTAQUES);
    return response?.data?.data;
  };

  const query = useQuery({
    enabled: true,
    queryFn: fetchData,
    queryKey: [props.queryKey || "listar_destaque"],
    refetchOnWindowFocus: false,
  });

  return query;
}
